import { useState, useEffect, useRef } from "react";

export const useScrollSpy = (
    sectionIds: string[],
    offset: number = 0
): string => {
    const [activeSection, setActiveSection] = useState<string>("");
    const intersectingIds = useRef<Set<string>>(new Set());

    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: `-${offset}px 0px -80% 0px`,
            threshold: 0,
        };

        const observerCallback = (entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    intersectingIds.current.add(entry.target.id);
                } else {
                    intersectingIds.current.delete(entry.target.id);
                }
            });

            const visibleId = sectionIds.find((id) => intersectingIds.current.has(id));

            if (visibleId) {
                setActiveSection(visibleId);
            }
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        sectionIds.forEach((id) => {
            const element = document.getElementById(id);
            if (element) {
                observer.observe(element);
            }
        });

        return () => {
            observer.disconnect();
            intersectingIds.current.clear();
        };
    }, [sectionIds, offset]);

    return activeSection;
};
